<div class="d-flex align-items-center bg-auth border-top border-top-2 border-primary"
     style="height: 100%;min-height:100%;">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12 col-md-6 col-xl-5 order-md-2 mb-5 mb-md-0">

        <!-- Image -->
        <div class="text-center">
          <img alt="..." class="img-fluid"
               src="/frontend/projects/app/src/assets/images/credit-card-failed.svg">
        </div>

      </div>
      <div class="col-12 col-md-6 col-xl-7 order-md-1 my-5">

        <div class="text-center">

          <!-- Preheading -->
          <h6 class="text-uppercase text-muted mb-4">
            Abonnement suspendu
          </h6>

          <!-- Heading -->
          <h1 class="display-4 mb-5">
            Votre abonnement est suspendu
          </h1>

          <p class="mb-4">
            Votre abonnement est maintenant suspendu. Pour continuer à utiliser Optitax, veuillez vous
            réabonner en cliquant sur le bouton ci-dessous.
          </p>

          <!-- Subheading -->
          <p class="text-muted mb-4">
            Vous avez des questions? Contactez-nous par clavardage et nous vous assisterons rapidement!
          </p>

          <!-- Button -->
          <a class="btn btn-lg btn-primary" routerLink="/organization/billing/subscription/upgrade">
            Me réabonner maintenant!
          </a>

        </div>

      </div>
    </div>
  </div>
</div>
